import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// Apple-inspired easing
const appleEase: [number, number, number, number] = [0.22, 1, 0.36, 1];
export default function LandingFooter() {
  return <footer className="py-12 md:py-16 border-t border-border/50 bg-background">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.8,
      ease: appleEase
    }} className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo with hover effect */}
          <motion.div className="group flex items-center gap-2.5 cursor-pointer" whileHover={{
          scale: 1.02,
          transition: {
            duration: 0.3,
            ease: appleEase
          }
        }}>
            <div className="w-14 h-14 rounded-lg overflow-hidden transition-all duration-300 group-hover:shadow-md">
              <img alt="UnlockEd Tutoring" width={56} height={56} loading="lazy" decoding="async" className="w-full h-full object-cover" src="/lovable-uploads/eafa6ba5-49b6-4688-9502-ef5e3e6cb8ca.webp" />
            </div>
            <span className="font-display font-bold text-xl tracking-tight transition-colors duration-300 group-hover:text-primary">UnlockEd Tutoring</span>
          </motion.div>

          {/* Links with underline animation */}
          <div className="flex flex-wrap gap-6 text-sm text-muted-foreground justify-center">
            <Link to="/resources" className="relative hover:text-foreground transition-colors duration-300 after:absolute after:left-0 after:bottom-[-2px] after:h-[1px] after:w-0 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
              TASC Exam Guides
            </Link>
            <Link to="/privacy" className="relative hover:text-foreground transition-colors duration-300 after:absolute after:left-0 after:bottom-[-2px] after:h-[1px] after:w-0 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
              Privacy
            </Link>
            <Link to="/terms" className="relative hover:text-foreground transition-colors duration-300 after:absolute after:left-0 after:bottom-[-2px] after:h-[1px] after:w-0 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
              Terms
            </Link>
            <Link to="/cookies" className="relative hover:text-foreground transition-colors duration-300 after:absolute after:left-0 after:bottom-[-2px] after:h-[1px] after:w-0 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
              Cookie Preferences
            </Link>
            <a href="mailto:support@unlockedtutoring.com.au" className="relative hover:text-foreground transition-colors duration-300 after:absolute after:left-0 after:bottom-[-2px] after:h-[1px] after:w-0 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">
              Support
            </a>
          </div>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground text-center md:text-right">
            © {new Date().getFullYear()} UnlockEd Tutoring. Made in Tasmania. Serving students statewide.
            <br className="hidden md:block" />
            <span className="text-xs text-muted-foreground/60">ABN 53 598 281 027</span>
          </p>
        </div>
      </motion.div>
    </footer>;
}